// City configuration for available markets awareness in search
// Featured cities appear at the top of search dropdowns before typing

import phoenixImg from "../images/cities/phoenix.jpg";
import eugeneImg from "../images/cities/eugene.jpg";

export const FEATURED_CITIES = [
  { city: "Phoenix", state: "AZ", displayName: "Phoenix, AZ", image: phoenixImg },
  { city: "Eugene", state: "OR", displayName: "Eugene, OR", image: eugeneImg },
];

// Oregon cities to hide - outside Lane County (Deschutes, Crook, Jefferson counties)
const HIDDEN_OREGON_CITIES = new Set([
  "bend", "la pine", "redmond", "sisters",       // Deschutes County
  "prineville", "powell butte",                   // Crook County
  "culver", "madras", "metolius",                 // Jefferson County
]);

/**
 * Check if a city should be hidden from the available locations display.
 * Currently hides non-Lane County Oregon cities.
 */
export const isHiddenCity = (city, state) => {
  if (!city || !state) return false;
  if (state.toLowerCase().trim() !== "or") return false;
  return HIDDEN_OREGON_CITIES.has(city.toLowerCase().trim());
};

/**
 * Check if a city/state combo is a featured market.
 */
export const isFeaturedCity = (city, state) => {
  if (!city || !state) return false;
  const cityLower = city.toLowerCase().trim();
  const stateLower = state.toLowerCase().trim();
  return FEATURED_CITIES.some(
    (fc) =>
      fc.city.toLowerCase() === cityLower &&
      fc.state.toLowerCase() === stateLower
  );
};

/**
 * Filter available cities by query string, with featured cities sorted first.
 */
export const filterAvailableCities = (allCities, query) => {
  if (!allCities || allCities.length === 0) return [];

  const q = (query || "").toLowerCase().trim();

  const mapped = allCities
    .filter((c) => !isHiddenCity(c.City || c.city, c.StateCode || c.state))
    .map((c) => ({
      city: c.City || c.city,
      state: c.StateCode || c.state,
      displayName: `${c.City || c.city}, ${c.StateCode || c.state}`,
      isFeatured: isFeaturedCity(c.City || c.city, c.StateCode || c.state),
    }));

  const filtered = q
    ? mapped.filter(
        (c) =>
          c.city.toLowerCase().startsWith(q) ||
          c.displayName.toLowerCase().startsWith(q)
      )
    : mapped;

  return filtered.sort((a, b) => {
    if (a.isFeatured && !b.isFeatured) return -1;
    if (!a.isFeatured && b.isFeatured) return 1;
    return a.city.localeCompare(b.city);
  });
};
